import React from 'react';
import { Modal, Row, Col, Input, Radio, message, Button, Spin } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import UserSearchInput from './UserSearchInput';
import UserDetail from '../user/UserDetail';
import MoreConditionUser from './MoreConditionUser';
import TransferPro from "./TransferPro";
import './css/list.less';

const InputGroup = Input.Group;
const RadioGroup = Radio.Group;
const confirm = Modal.confirm;
const initState = {
    visible: false,
    confirmLoading: false,
    investigationId: '',
    investigation: {},
    pmList: [],
    paList: [],
    bdList: [],
    casList: [],
    change: false,
    selectRole: "PM",
    selectUser: {},
    spinning: false,
    rerender: false,
}

class DelegateUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = initState;
    }

    show = (id, change) => {
        this.setState({
            investigationId: id,
            visible: true,
            change: change ? true : false,
        }, () => {
            this.loadModalData()
        });
    }

    loadModalData = () => {
        const { investigationId } = this.state;
        this.setState({ spinning: true });
        const options = {
            method: 'POST',
            url: `${API_URL.execute.view}`,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: data => {
                const investigation = data.data.investigation;
                let pmList = [], paList = [], bdList = [], casList = [], pmaList = [];
                if (investigation.pmUserList && investigation.pmUserList.length > 0) {
                    pmList = investigation.pmUserList.map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                        isMain: user.isMain,
                    }));
                }
                if (investigation.paUserList && investigation.paUserList.length > 0) {
                    paList = investigation.paUserList.map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                }
                if (investigation.pmaList && investigation.pmaList.length > 0) {
                    pmaList = investigation.pmaList.map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                }
                if (investigation.bdUserList && investigation.bdUserList.length > 0) {
                    bdList = investigation.bdUserList.map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                }
                if ( investigation.casList && investigation.casList.length > 0 ) {
                    casList = investigation.casList.map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                        createType: user.createType,
                    }));
                }
                this.setState({
                    investigation,
                    paList,
                    pmList,
                    pmaList,
                    bdList,
                    casList,
                    spinning: false,
                });
            },
            errorResult: () => {
                this.setState({ spinning: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    hide = () => {
        this.setState({
            ...initState,
            rerender: true,
        }, () => {
            this.setState({ rerender: false });
        });
    }

    hasElement = (listArr, eleVal) => {
        let has = false;
        listArr.map(val => {
            if (val.value == eleVal) {
                has = true;
                return;
            }
        })
        return has;
    }

    addFromCondition = (role, addList = []) => {
        const { selectRole, investigationId } = this.state;
        let idx = 0;
        const userParams = {};
        this.setState({
            spinning: true,
        })
        addList.map(user => {
            userParams['users[' + idx + '].roleCode'] = selectRole;
            userParams['users[' + idx + '].userId'] = user.value;
            idx++;
        });

        const options = {
            url: `${API_URL.investigation.addMember}` + '?' + userParams,
            data: {
                investigationId,
                ...userParams,
            },
            dataType: 'json',
            doneResult: () => {
                this.loadModalData();
            },
            errorResult: () => {
                this.setState({ spinning: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    selectMainPM = (value) => {
        confirm({
            title: '确定设置该人员为大项目经理吗?',
            onOk: () => {
                const { investigationId } = this.state;
                this.setState({ spinning: true });
                const options = {
                    url: `${API_URL.investigation.changePMA}`,
                    data: {
                        investigationId,
                        userId: value,
                    },
                    dataType: 'json',
                    doneResult: () => {
                        this.loadModalData();
                    },
                    errorResult: () => {
                        this.setState({ spinning: false });
                    },
                };
                AjaxRequest.sendRequest(options);
            },
        });
    }

    getPMSource = () => {
        const { pmList } = this.state;
        return (
            <div>
                {
                    (pmList || []).map(user =>
                        <Row key={user.value}>
                            <Col span={12}>
                                <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                            </Col>
                            <Col span={8}>
                                {
                                    (pmList.length > 1) &&
                                    <Radio onClick={() => {
                                        if (user.isMain != 1) {
                                            this.selectMainPM(user.value)
                                        }
                                    }} checked={user.isMain == 1}>大项目经理</Radio>
                                }
                            </Col>
                            <Col span={2}>
                                <Button type="primary" shape="circle" icon="close" size='small' onClick={this.confirmRemove.bind(this, user.value, 'PM')} />
                                </Col>
                            <Col span={2}>
                                {this.state.change && <div style={{ color: "#fff", marginTop: "3px", cursor: "pointer", backgroundColor: "#fdaf32", borderRadius: "9px", width: "18px", height: "18px", lineHeight: "18px", textAlign: "center" }}><i style={{ fontSize: "14px" }} onClick={this.transferPro.bind(this, user, 'PM')} className="icon iconfont">&#xe62a;</i></div>}
                            </Col>
                        </Row>
                    )
                }
            </div>
        );
    }

    getPASource = () => {
        const { paList } = this.state;
        return (
            <div>
                {
                    (paList || []).map(user =>
                        <Row key={user.value}>
                            <Col span={20}>
                                <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                            </Col>
                            <Col span={2}><Button type="primary" shape="circle" icon="close" size='small' onClick={this.confirmRemove.bind(this, user.value, 'PA')} /></Col>
                            <Col span={2}>{this.state.change && <div style={{ color: "#fff", marginTop: "3px", cursor: "pointer", backgroundColor: "#fdaf32", borderRadius: "9px", width: "18px", height: "18px", lineHeight: "18px", textAlign: "center" }}><i style={{ fontSize: "14px" }} onClick={this.transferPro.bind(this, user, 'PA')} className="icon iconfont">&#xe62a;</i></div>}</Col>
                        </Row>
                    )
                }
            </div>
        );
    }

    getPMASource = () => {
        const { pmaList } = this.state;
        return (
            <div>
                {
                    (pmaList || []).map(user =>
                        <Row key={user.value}>
                            <Col span={20}>
                                <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                            </Col>
                            <Col span={4}><Button type="primary" shape="circle" icon="close" size='small' onClick={() => this.confirmRemove(user.value, 'PMA')} /></Col>
                        </Row>
                    )
                }
            </div>
        );
    }

    getBDSource = () => {
        const { bdList } = this.state;
        return (
            <div>
                {
                    (bdList || []).map(user =>
                        <Row key={user.value}>
                            <Col span={20}>
                                <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                            </Col>
                            <Col span={4}><Button type="primary" shape="circle" icon="close" size='small' onClick={() => this.confirmRemove(user.value, 'BD')} /></Col>
                        </Row>
                    )
                }
            </div>
        );
    }

    getCSASource = () => {
        const { casList } = this.state;
        return (
            <div>
                {
                    (casList || []).map(user =>
                        <Row key={user.value}>
                            <Col span={20}>
                                <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                            </Col>
                            { user.createType !== 'CSA_AUTOMATIC' &&
                            <Col span={4}><Button type="primary" shape="circle" icon="close" size='small' onClick={() => this.confirmRemove(user.value, 'CSA')} /></Col>}
                        </Row>
                    )
                }
            </div>
        );
    }

    handleSubmit = () => {
        const { pmList = [], paList, bdList = [], casList = [], investigationId } = this.state;
        if (!this.checkHasMainPM() && pmList.length > 1) {
            message.error("配置多个项目经理时，需要标识哪个是大项目经理");
            return;
        }
        if (bdList.length == 0) {
            message.error("BD不能为空，请添加BD");
            return;
        }
        let idx = 0;
        let userParams = '';
        if (pmList.length == 1) {
            pmList.map(user => {
                if (userParams.length > 0) {
                    userParams += '&';
                }
                userParams += 'users[' + idx + '].userId=' + user.value;
                userParams += '&users[' + idx + '].roleCode=PM';
                userParams += '&users[' + idx + '].isMain=' + 1;
                idx++;
            });
        } else {
            pmList.map(user => {
                if (userParams.length > 0) {
                    userParams += '&';
                }
                userParams += 'users[' + idx + '].userId=' + user.value;
                userParams += '&users[' + idx + '].roleCode=PM';
                userParams += '&users[' + idx + '].isMain=' + (user.isMain || 0);
                idx++;
            });
        }

        paList.map(user => {
            if (userParams.length > 0) {
                userParams += '&';
            }
            userParams += 'users[' + idx + '].userId=' + user.value;
            userParams += '&users[' + idx + '].roleCode=PA';
            idx++;
        });
        bdList.map(user => {
            if (userParams.length > 0) {
                userParams += '&';
            }
            userParams += 'users[' + idx + '].userId=' + user.value;
            userParams += '&users[' + idx + '].roleCode=BD';
            idx++;
        });
        casList.map(user => {
            if (userParams.length > 0) {
                userParams += '&';
            }
            userParams += 'users[' + idx + '].userId=' + user.value;
            userParams += '&users[' + idx + '].roleCode=CSA';
            idx++;
        });
        const options = {
            url: `${API_URL.investigation.appointMember}` + '?' + userParams,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: () => {
                this.setState(initState);
            },
        };
        AjaxRequest.sendRequest(options);
    }

    viewUser = userId => {
        this.userDetailRef.show(userId);
    }

    onAddRoleChange = (e) => {
        this.setState({
            selectRole: e.target.value
        })
    }

    handleSelectUser = value => {
        this.setState({
            selectUser: value,
        });
    }

    onAddUser = () => {
        const { selectRole, selectUser = {}, investigationId } = this.state;
        if (!selectUser.value) {
            return;
        }
        this.setState({ spinning: true });
        let userParams = '';
        userParams += 'users[0].userId=' + selectUser.value;
        userParams += '&users[0].roleCode=' + selectRole;
        const options = {
            url: `${API_URL.investigation.addMember}` + '?' + userParams,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: data => {
                this.loadModalData();
            },
            errorResult: () => {
                this.setState({ spinning: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    confirmRemove = (value, role) => {
        const { investigationId, bdList = [] } = this.state;
        if (role === "BD") {
            if (bdList.length <= 1) {
                Modal.error({ title: "BD为必填，无法删除最后一个BD" });
                return;
            }
        }

        confirm({
            title: '确定删除该人员吗?',
            onOk: () => {
                this.remove(value, role, investigationId, 0);
            },
        });
    }

    remove = (value, role, investigationId, isCheck) => {
        this.setState({ spinning: true });
        const options = {
            url: API_URL.investigation.deleteMember,
            data: {
                isCheck,
                investigationId,
                userId: value,
                roleCode: role
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({ spinning: false }, () => {
                    this.loadModalData();
                });
            },
            errorResult: () => {
                this.setState({ spinning: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    transferPro = (user, roleCode) => {
        this.transferProRef.show(user, roleCode);
    }

    moreUser = () => {
        this.moreUserRef.show('');
    }

    render() {
        const { visible, confirmLoading, investigation, change, selectRole, spinning, rerender, investigationId } = this.state;
        return (
            <div>
                <Modal
                    title={change ? "变更人员" : "委派人员"}
                    visible={visible}
                    onCancel={this.hide}
                    className="create-modal delegate-modal"
                    wrapClassName="vertical-center-modal"
                    width={650}
                    bodyStyle={{ maxHeight: 450 }}
                    confirmLoading={confirmLoading}
                    footer={[
                        <Button key="back" size="large" onClick={this.hide}>关闭</Button>,
                    ]}
                >
                    <Spin spinning={spinning}>
                        <div className="set_role_users">
                            <div className="set_role_content">
                                <Row>
                                    <Col span={6}>项目简称：</Col>
                                    <Col span={1} />
                                    <span style={{
                                        whiteSpace: 'break-spaces',
                                        display: 'inline-block',
                                        width: '70%',
                                    }}>{investigation.investigationName}</span>
                                </Row>
                                <Row>
                                    <Col span={6}>项目编号：</Col>
                                    <Col span={1} />
                                    <Col>{investigation.investigationCode}</Col>
                                </Row>
                                <Row>
                                    <Col span={6}>项目经理：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div className="select-gay">
                                            {this.getPMSource()}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}>项目管理员：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            {this.getPASource()}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}>协助项目成员：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            {this.getPMASource()}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}><span className="red_sim">*</span>BD：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            {this.getBDSource()}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}>CSA：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            {this.getCSASource()}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="setrole_add">
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}>添加人员：</Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            <RadioGroup onChange={this.onAddRoleChange} value={selectRole}>
                                                <Radio value="PM">项目经理</Radio>
                                                <Radio value="PA">项目管理员</Radio>
                                                <Radio value="PMA">协助项目成员</Radio>
                                                <Radio value="BD">BD</Radio>
                                                <Radio value="CSA">CSA</Radio>
                                            </RadioGroup>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}></Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div className="select-gay">
                                            {
                                                !rerender &&
                                                <InputGroup compact>
                                                    <UserSearchInput
                                                        style={{ width: 130, marginBottom: 10 }}
                                                        handleSelectUser={this.handleSelectUser}
                                                        url={`${API_URL.team.userlist}`}
                                                        placeholder="工号或姓名"
                                                        searchKey='keyword'
                                                        dropdownClassName="user-auto-search"
                                                        dropdownAlign={{
                                                            points: ['bl', 'tl'], // align dropdown bottom-left to top-left of input element
                                                            offset: [0, -4], // align offset
                                                            overflow: {
                                                                adjustX: 0,
                                                                adjustY: 0, // do not auto flip in y-axis
                                                            },
                                                        }}
                                                    />
                                                    <Button style={{ marginBottom: 10 }} type="Default" onClick={this.moreUser}>更多</Button>
                                                </InputGroup>
                                            }
                                            <Button style={{ display: 'inline-block', marginBottom: 10, marginLeft: 20, marginTop: 10 }} type="primary" onClick={this.onAddUser}>添加</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <UserDetail ref={el => { this.userDetailRef = el; }} />
                    </Spin>
                </Modal>
                <MoreConditionUser ref={el => { this.moreUserRef = el; }} addFromCondition={this.addFromCondition} />
                <TransferPro
                    ref={el => { this.transferProRef = el; }}
                    investigationName={investigation.investigationName}
                    investigationCode={investigation.investigationCode}
                    investigationId={investigationId}
                    loadData={this.loadModalData} />
            </div>
        )
    }
}

export default DelegateUser;


// WEBPACK FOOTER //
// ./src/components/investigation/SetRoleUsers.js